// extracted by mini-css-extract-plugin
export default {"button-list":"styles_button-list__I3rxx"};